import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from '../../areas/user/auth/providers/user.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

    constructor(private readonly router: Router, private readonly userService: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       return next.handle(request).pipe(tap(() => { }, (error: any) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status !== 401) {
                    return;
                }

                this.userService.clearAuthState().subscribe(() => {
                    this.router.navigate(['/']);
                });
            }
        }));
    }
}
